module.exports = __webpack_public_path__ + "static/media/add_video.a52e8b8d.svg";